import React, { Suspense, useEffect, useMemo, useState } from "react";
import LoadingSpinner from "../../components/UI/loadingSpinner/LoadingSpinner";
import { ROUTES } from "../../constants/routes";
import { PAGINATION_SEQUENCE } from "../../constants";
import { Icon } from "@iconify/react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import DataTable, { TableColumn } from "react-data-table-component";
import { IShop } from "../../interfaces/shop.interface";
import { getApi } from "../../services/http.service";
import { Link } from "react-router-dom";
import { STATES_OPTIONS } from "../../constants/states";
import DateRangeDropdown from "../../components/UI/date-range-dropdown/DateRangeDropdown";
import Dropdown from "../../components/UI/dropdown/Dropdown";
import { IDistributor } from "../../interfaces/distributor.interface";
import { IStock } from "../../interfaces/stock.interface";
import { PARTY_DETAILS_COLUMNS } from "./columns";
import moment from "moment";

function PartyDetail() {
  const fUrl = process.env.REACT_APP_FILE_URL;
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const [queryParams] = useSearchParams();
  // Data & Search
  const [state, setState] = useState("");
  const [startDate, setStartDate] = useState(queryParams.get("startDate"));
  const [endDate, setEndDate] = useState(queryParams.get("endDate"));
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState<IStock[]>([]);
  const [distributorData, setDistributorData] = useState<IDistributor>();
  const [show, setShow] = useState(false);
  useEffect(() => {
    fetchNews(page, perPage, search);
  }, [page, perPage, search, state, startDate, endDate]);

  const fetchNews = async (page: number, limit: number, search: string) => {
    try {
      setLoading(true);
      const result = await getApi(
        ROUTES.DISTRIBUTOR_BY_ID + params?.id + "/party-detail",
        {
          page,
          limit,
          search,
          startDate,
          endDate,
          state,
        }
      );
      if (result.code === 200) {
        setFilteredData(result?.data);
        setTotalRows(result.total); // Set total records
        setDistributorData(result?.distributor);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // Handle Page Change
  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  // Handle Rows per Page Change
  const handlePerRowsChange = (newPerPage: number, newPage: number) => {
    setPerPage(newPerPage);
    setPage(newPage);
  };

  const deleteRow = (item: IShop) => {
    console.log(item);
  };

  const columns: TableColumn<IStock>[] = useMemo(
    () => PARTY_DETAILS_COLUMNS,
    []
  );

  async function selectedChangeHandler(e: any) {
    const s = e[0].toString();
    const en = e[1]?.toString();
    if (s && en) {
      setStartDate(s);
      setEndDate(en);
    }
  }

  function stateChangeHandler(e: React.ChangeEvent<HTMLSelectElement>) {
    setState(() => e.target.value);
  }
  return (
    <section>
      <div className="d-flex justify-content-between align-items-center flex-wrap">
        <div className="d-flex align-items-center">
          <button className="nav-link" onClick={() => navigate(-1)}>
            <Icon icon="material-symbols:arrow-back-rounded" fontSize={25} />
          </button>
          <h2 className="title mb-2"> Party Details</h2>
        </div>
        <div className="d-flex flex-wrap align-items-center">
          <Dropdown
            customClass="mb-0"
            dropdownData={STATES_OPTIONS}
            bindLabel="state"
            bindValue="state"
            selected={state}
            label="State"
            onChange={stateChangeHandler}
          />
          <DateRangeDropdown onChange={selectedChangeHandler} />
        </div>
      </div>
      <div className="position-relative">
        <h6 className="mb-3">Party: {distributorData?.firmName}</h6>

        <table className="table table-bordered table-striped table-sm">
          <tbody>
            <tr>
              <th>Email</th>
              <td>{distributorData?.email || "-"}</td>
            </tr>
            <tr>
              <th>Phone</th>
              <td>{distributorData?.phone || "-"}</td>
            </tr>
            <tr>
              <th>Owner Name</th>
              <td>{distributorData?.directorName || "-"}</td>
            </tr>
            <tr>
              <th>Address</th>
              <td>
                {distributorData?.address?.street}{" "}
                {distributorData?.address?.city}{" "}
                {distributorData?.address?.state}{" "}
                {distributorData?.address?.country} -{" "}
                {distributorData?.address?.pincode}
              </td>
            </tr>
            <tr>
              <th>Order Amount</th>
              <td>{distributorData?.orderAmount || "NA"}</td>
              <th>Secondary Number</th>
              <td>{distributorData?.secondaryNumber || "NA"}</td>
            </tr>
         
            <tr>
              <th>Last Updated</th>
              <td>{moment(distributorData?.lastOrderDate).format("DD MMM YYYY hh:mm A") || "NA"}</td>
            </tr>
            {distributorData?.visitedPhoto && (
              <tr>
                <th>Visited Image</th>
                <td>
                  <img
                    src={fUrl + distributorData?.visitedPhoto}
                    alt={distributorData?.firmName}
                    style={{ maxWidth: "150px", borderRadius: "5px" }}
                  />
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="position-absolute top-0 end-0">
          <Link
            to={`/distributors/${distributorData?._id}`}
            title="View Employee"
          >
            <Icon
              icon="material-symbols:frame-person-sharp"
              type="button"
              color="#9bcb51"
              style={{ marginInline: 5 }}
              fontSize={25}
            />
          </Link>
        </div>
      </div>

      <Suspense>
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          paginationPerPage={perPage}
          paginationRowsPerPageOptions={[15, 50, 100]}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          highlightOnHover
          striped
          progressPending={loading}
          progressComponent={<LoadingSpinner />}
        />
      </Suspense>
    </section>
  );
}

export default PartyDetail;
